import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../service/auth.service';
import { AppService } from 'src/app/services/app/app.service';
import { ROUTES } from 'src/app/layout/sidebar/sidebar-items';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  public currentParentURL: string = '';
  public userData;
  public userType !:string;
  public routeData:any[]=[]
  constructor(private authService: AuthService, private router: Router,private appService:AppService) {
   

  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.appService.getData('training-portal.userInfo')) {
      return true;
    }
    this.router.navigate(['/authentication/signin']);
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot,state: RouterStateSnapshot) {
    this.userData=JSON.parse(this.appService.getData('training-portal.userInfo'))
    this.userType=this.userData.group_type
   
    this.routeData= ROUTES.filter((sidebarItem) => (sidebarItem.userType.includes(this.userType)))

    return true;
}
}
